import Tdg_MapItemModelBase from '../_generated/modelBases/tdg-map-item-model-base';

export default class Tdg_MapItemModel extends Tdg_MapItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
